import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{attrs:{"dark":"","padless":""}},[_c(VCard,{staticClass:"text-center",attrs:{"flat":"","tile":"","min-width":"100%","height":"60px"}},[_c('div',{staticStyle:{"position":"absolute","top":"0%","right":"3%"}},[_c('dark-mode')],1),_c(VCardText,[_vm._v(" "+_vm._s(new Date().getFullYear())+" "),_c('strong',[_vm._v("@Juan Aquino - juanpatricioaquino@gmail.com")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }